const firebaseConfig = {
  apiKey: "AIzaSyD_AU9siUxmsR-uJ7oCh2Lkrgl1i5Fu960",
  authDomain: "electronics-pivot.firebaseapp.com",
  projectId: "electronics-pivot",
  storageBucket: "electronics-pivot.appspot.com",
  messagingSenderId: "1020525520878",
  appId: "1:1020525520878:web:4f82d19f8c3c10255e50ff"
};

export default firebaseConfig;